import React, { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Button from '../components/Button';
import FormField, { Input } from '../components/FormField';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(form.username, form.password);
      navigate(user.role === 'admin' || user.role === 'superadmin' ? '/admin' : '/my-tickets');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-4 sm:mt-8">
      <div className="text-center mb-8">
        <div className="text-4xl mb-2">👋</div>
        <h1 className="text-2xl font-bold text-ocean-900">Willkommen zurück!</h1>
        <p className="text-slate-500 mt-1 text-sm">Melde dich an um dein Ticket zu verwalten</p>
      </div>

      <div className="card">
        {params.get('registered') && (
          <div className="alert-success mb-4">✅ Registrierung erfolgreich! Du kannst dich jetzt anmelden.</div>
        )}
        {error && <div className="alert-error mb-4">{error}</div>}

        <form onSubmit={handleSubmit}>
          <FormField label="Benutzername oder E-Mail" required>
            <Input value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })}
              autoComplete="username" placeholder="dein.name@beispiel.de" required />
          </FormField>
          <FormField label="Passwort" required>
            <Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
              autoComplete="current-password" placeholder="••••••••" required />
          </FormField>
          <div className="text-right mb-2">
            <Link to="/reset-password" className="text-xs text-ocean-500 hover:text-ocean-700 no-underline">
              Passwort vergessen?
            </Link>
          </div>
          <Button type="submit" loading={loading} className="w-full mt-2">Anmelden</Button>
        </form>

        <p className="text-center mt-4 text-sm text-slate-500">
          Noch kein Konto?{' '}
          <Link to="/register" className="font-semibold text-ocean-600 hover:text-ocean-800 no-underline">Jetzt registrieren</Link>
        </p>
      </div>
    </div>
  );
}
